/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager';
import { StyledSection } from './styles';
import { WrapperProps } from './index.types';
import clsx from 'clsx';

const StaticWrapperReact: FC<WrapperProps> = (props: any) => {
  const { referencePath, enableModalPortal } = props;
  const [mounted, setMounted] = useState(false);
  const [mainContent, setMainContent] = useState(referencePath || '');
  const [portalContent, setPortalContent] = useState('');

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!enableModalPortal || !referencePath) {
      setMainContent(referencePath || '');
      setPortalContent('');
      return;
    }

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = referencePath;

    const modalDialogs = tempDiv.querySelectorAll('.mdc-dialog');
    let extractedModals = '';

    modalDialogs.forEach(modal => {
      extractedModals += modal.outerHTML;
      modal.remove();
    });

    setMainContent(tempDiv.innerHTML);
    setPortalContent(extractedModals);
  }, [referencePath, enableModalPortal]);

  return (
    <StyledSection data-component-name="o-common-static-staticwrapper">
      <section
        dangerouslySetInnerHTML={{ __html: mainContent }}
        className={`${AuthoringUtils.isInEditor() ? 'authorBorder' : ''}`}
      />
      {enableModalPortal &&
        mounted &&
        portalContent &&
        createPortal(<div dangerouslySetInnerHTML={{ __html: portalContent }} />, document.body)}
    </StyledSection>
  );
};

export const StaticWrapperConfig = {
  emptyLabel: 'staticWrapper',
  isEmpty: false,
  resourceType: `mi-aem-common-spa/components/common/staticwrapper`,
};

export const StaticWrapperEditable = (props: any) => {
  return (
    <EditableComponent
      config={StaticWrapperConfig}
      {...props}
      isInEditor={!props.cqPath.includes('experiencefragment')}
    >
      <StaticWrapperReact enableModalPortal={props.enableModalPortal} />
    </EditableComponent>
  );
};

export const StaticWrapper = (props: any) => {
  return props?.model?.styleclass ? (
    <div
      className={clsx(
        props?.model?.styleclass,
        props?.model?.styleclass.includes('fullbleed') ? 'm-container-fullbleed' : ''
      )}
    >
      <StaticWrapperEditable {...props} />
    </div>
  ) : (
    <StaticWrapperEditable {...props} />
  );
};
